/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Who_FreeInputs */



/**
* | output |
* | --- |
* | "For trying it out and occasional projects" |
*
* @param {Signup_Compare_Who_FreeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_who_free = /** @type {((inputs?: Signup_Compare_Who_FreeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Who_FreeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("For trying it out and occasional projects")
	if (locale === "de") return /** @type {LocalizedString} */ ("For trying it out and occasional projects")
	if (locale === "it") return /** @type {LocalizedString} */ ("For trying it out and occasional projects")
	if (locale === "ru") return /** @type {LocalizedString} */ ("For trying it out and occasional projects")
	if (locale === "es") return /** @type {LocalizedString} */ ("For trying it out and occasional projects")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("For trying it out and occasional projects")
	if (locale === "ja") return /** @type {LocalizedString} */ ("For trying it out and occasional projects")
	if (locale === "hi") return /** @type {LocalizedString} */ ("For trying it out and occasional projects")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("For trying it out and occasional projects")
	return /** @type {LocalizedString} */ ("For trying it out and occasional projects")
});